module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Header', {
    staticClass: "black"
  }), _vm._v(" "), _c('div', {
    staticClass: "per-set",
    staticStyle: {
      "min-height": "678px"
    }
  }, [_c('ul', _vm._l((_vm.menuList), function(item, index) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.liClick(index)
        }
      }
    }, [_c('router-link', {
      class: {
        'menu-active': !_vm.$route.path.indexOf(item.path)
      },
      attrs: {
        "to": item.path
      }
    }, [_c('Icon', {
      attrs: {
        "type": item.icon
      }
    }), _vm._v("\n          " + _vm._s(item.name) + "\n        ")], 1)], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "per-con"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1eb32cc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal/person.vue
// module id = 1300
// module chunks = 32